<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FullContainerAdditionalInformationDetails')"
    width="840px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view fcl-extra-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column" style="width: 400px">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="freightType" required :label="$t('Pricing.PriceType')">
                <cargo-advance-select
                  no="freightType"
                  :static-options="priceTypes"
                  tag-value="code"
                  :default-value="price.freightType"
                  :clearable="false"
                  @parentCallBack="p=>{price.freightType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pol" required :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" required :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item ref="carrier" required :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Lane')">
                <el-input
                  v-model="price.lane"
                  no="lane"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item ref="frequency" :label="$t('Pricing.DepartureDay')">
                <el-input
                  no="frequency"
                  :disabled="true"
                  :value="frequency"
                />
              </el-form-item>
              <el-radio-group v-model="frequency" no="frequency">
                <div style="display: flex; width: 100%">
                  <el-radio no="radio1" :label="1" />
                  <el-radio no="radio2" :label="2" />
                  <el-radio no="radio3" :label="3" />
                  <el-radio no="radio4" :label="4" />
                  <el-radio no="radio5" :label="5" />
                  <el-radio no="radio6" :label="6" />
                  <el-radio no="radio7" :label="7" />
                </div>
              </el-radio-group>
              <el-form-item :label="$t('Pricing.Dockland')">
                <el-input
                  v-model="price.dockland"
                  no="dockland"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column" style="width: 400px">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.ShareCarriers')" prop="shareCarrier">
                <div style="display: flex">
                  <cargo-advance-select
                    no="carrier"
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{seaCmp:true}"
                    filterable
                    :default-value="fclExtraForm.carrier"
                    :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                    :show-custom-label-in-option="true"
                    tag-value="cmpIdx"
                    style="flex: 1"
                    @parentCallBack="item=>fclExtraForm.carrier=item.value"
                  />
                  <span class="form-operator" @click="onPriceSubscribeFormAdd('carrier')"><i class="el-icon-circle-plus" /></span>
                  <span class="form-operator" @click="onPriceSubscribeFormRemove('carrier')"><i class="el-icon-remove" /></span>
                </div>
              </el-form-item>
              <el-form-item class="custom" prop="shareCarrierCodes">
                <el-checkbox-group v-model="fclExtraForm.carrierCodes" no="carrierCodes">
                  <el-col
                    v-for="code in carrierCheckBoxGroup"
                    :key="code"
                    :span="24"
                  >
                    <el-checkbox no="code" :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Company, 'cmpIdx', Number(code), 'shortName') }}</el-checkbox>
                  </el-col>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item :label="$t('Pricing.BillType')">
                <el-input
                  v-model="price.billType"
                  no="billType"
                  :maxlength="16"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ShippingClause')">
                <el-input
                  v-model="price.shippingTerm"
                  no="shippingTerm"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item label="SEAWAY BILL">
                <cargo-advance-select
                  no="seawayBill"
                  :static-options="seawayBills"
                  tag-name="chineseName"
                  tag-value="code"
                  :default-value="price.seawayBill"
                  @parentCallBack="p=>{price.seawayBill=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.FreeContainerPeriod')">
                <div style="display: flex">
                  <cargo-advance-select
                    v-if="!price.freeTimeNil"
                    no="freeContainerPeriodType"
                    :static-options="freeTimeType"
                    tag-name="chineseName"
                    tag-value="code"
                    :default-value="price.freeContainerPeriodType"
                    @parentCallBack="p=>{price.freeContainerPeriodType=p.value}"
                  />
                  <el-checkbox v-model="price.freeTimeNil" no="freeTimeNil" style="margin-left: 5px">NIL</el-checkbox>
                </div>
                <div v-if="price.freeContainerPeriodType === 0 && !price.freeTimeNil" style="display: flex; margin: 5px 0px;">
                  <span style="margin-right: 10px; width: 25%">DEM+DET</span>
                  <el-input-number v-model="price.freeContainerPeriod" style="width: 75%" :min="0" :max="100" no="freeContainerPeriod" :controls="false" />
                </div>
                <div v-if="price.freeContainerPeriodType === 1 && !price.freeTimeNil" style="display: flex; margin: 5px 0px;">
                  <span style="margin-right: 5px; width: 80px">DEM</span>
                  <el-input-number v-model="price.dem" :min="0" :max="100" no="dem" :controls="false" />
                  <span style="margin: 0px 5px; width: 80px">DET</span>
                  <el-input-number v-model="price.det" :min="0" :max="100" no="det" :controls="false" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.OtherInfo')">
                <el-input v-model="price.otherInfo" no="otherInfo" type="textarea" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { savePriceFclExtra } from '@/api/price/priceFclExtra'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { isNumber } from '@/utils/validate'

export default {
  name: 'FclExtraForm',
  components: { CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    },
    isCp: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      priceTypes: PriceConstant.PRICE_ALL_TYPES,
      freeTimeType: PriceConstant.FREE_TIME_TYPE,
      resolveColumnLabel: ColumnUtils.resolveColumnLabel,
      fullscreenLoading: null,
      seawayBills: PriceConstant.PRICE_SEAWAY_BILL,
      fclExtraForm: {
        carrierCodes: [],
        carrier: ''
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    frequency: {
      get() {
        const FREQUENCIES = PriceUtils.FREQUENCYS
        for (const field of FREQUENCIES) {
          if (this.price['frequency' + field]) {
            return Number(field)
          }
        }
        return null
      },
      set(val) {
        const FREQUENCIES = PriceUtils.FREQUENCYS
        for (const field of FREQUENCIES) {
          this.price['frequency' + field] = Number(field) === val
        }
      }
    },
    carrierCheckBoxGroup: {
      get() {
        if (StrUtils.isEmpty(this.price.shareCarrier)) {
          return []
        }
        return this.price.shareCarrier.split(',').filter(item => !StrUtils.isEmpty(item))
      },
      set(val) {
        this.price.shareCarrier = val.join(',')
      }
    }
  },
  watch: {
    'price.freeTimeNil': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.price.freeContainerPeriodType = ''
          this.price.freeContainerPeriod = ''
          this.price.dem = ''
          this.price.det = ''
        }
      }
    },
    'price.freeContainerPeriodType': {
      handler(newValue, oldValue) {
        if (newValue === 0) {
          this.price.dem = ''
          this.price.det = ''
        }
        if (newValue === 1) {
          this.price.freeContainerPeriod = ''
        }
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.verifyForm()) {
        return
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      // 校验免柜期
      if (!this.price.freeTimeNil) {
        if (this.price.freeContainerPeriodType === PriceConstant.FREE_TIME_CONSOLIDATE.code &&
          !isNumber(this.price.freeContainerPeriod)) {
          this.$message.warning(this.$t('Pricing.PleaseInput', ['DEM+DET']))
          return
        }
        if (this.price.freeContainerPeriodType === PriceConstant.FREE_TIME_RESPECTIVELY.code) {
          const array = []
          if (!isNumber(this.price.dem)) {
            array.push('DEM')
          }
          if (!isNumber(this.price.det)) {
            array.push('DET')
          }
          if (array.length > 0) {
            this.$message.warning(this.$t('Pricing.PleaseInput', [array.join(',')]))
            return
          }
        }
      }
      if (StrUtils.isEmpty(this.price.shareCarrier) && !StrUtils.isEmpty(this.fclExtraForm.carrier)) {
        this.price.shareCarrier = this.fclExtraForm.carrier
      }
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.save()
    },
    save() {
      this.fullscreenLoading = getLoading()
      let changeState = false
      if (!this.isNew && this.price.state === 1) {
        this.price.state = 0
        changeState = true
      }
      savePriceFclExtra(this.price).then((res) => {
        this.fullscreenLoading.close()
        if (res.data) {
          if (!changeState) {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          }
          this.$emit('reload')
        } else {
          this.$message.success(this.$t('Message.SaveFailed'))
        }
        this.$emit('close')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (field === 'frequency') {
        return StrUtils.isEmpty(this.frequency)
      }
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0 && field !== 'freightType'
      }
      return StrUtils.isEmpty(this.price[field])
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    },
    onPriceSubscribeFormAdd(type) {
      const code = this.fclExtraForm[`${type}`]
      if (code) {
        if (this[`${type}CheckBoxGroup`].indexOf(code) === -1) {
          const newCheckBoxGroup = [...this[`${type}CheckBoxGroup`], code]
          this[`${type}CheckBoxGroup`] = newCheckBoxGroup
          this.fclExtraForm[`${type}`] = ''
        }
      } else {
        const code = this[`${type}CheckBoxGroup`][this[`${type}CheckBoxGroup`].length - 1]
        this.fclExtraForm[`${type}Codes`] = [...this.fclExtraForm[`${type}Codes`], code]
      }
    },
    onPriceSubscribeFormRemove(type) {
      this[`${type}CheckBoxGroup`] = this[`${type}CheckBoxGroup`].filter(code => this.fclExtraForm[`${type}Codes`].indexOf(code) === -1)
      this.fclExtraForm[`${type}Codes`] = this.fclExtraForm[`${type}Codes`].filter(code => this[`${type}CheckBoxGroup`].indexOf(code) !== -1)
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .fcl-extra-form{
    .el-radio-group{
      margin-bottom: 8px;
      margin-top: 8px;
    }
    .el-radio{
      margin-right: 10px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
